<template>
  <v-card class="main-card">
    <v-card-title class="screen-title">
      <span>通知連絡先情報</span>
      <manual-button path="/notification-contact-address/" />
    </v-card-title>
    <v-card-text class="pa-5 d-flex flex-column content" v-if="isLoaded">
      <div class="d-flex justify-end mb-2">
        <v-btn
          color="primary"
          v-permission.config
          @click="editNotificationContact"
        >
          編集
        </v-btn>
      </div>
      <v-card class="main-card">
        <v-row>
          <v-col>
            <app-label-group label="V番号" :value="contractSummary.vnumber" />
          </v-col>
          <v-icon
            icon="$mdiCached"
            size="x-large"
            color="primary"
            @click="load"
          ></v-icon>
        </v-row>

        <v-row>
          <v-col>
            <app-label-group
              label="お知らせ通知受信"
              :value="
                $filter.enumTo(
                  notificationContactInfo.receivesNotifications,
                  'on_off'
                )
              "
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <app-label-group
              label="お知らせ受信種別"
              :value="
                notificationContactInfo.receivingType.receivesNotice
                  ? 'その他お知らせ'
                  : '-'
              "
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <app-label-group label="通知先メールアドレス">
              <template #value>
                <div class="ml-3">
                  <p
                    v-for="(
                      mail, i
                    ) in notificationContactInfo.notificationMailList"
                    :key="i"
                  >
                    {{ mail }}
                  </p>
                </div>
              </template>
            </app-label-group>
          </v-col>
        </v-row>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import type { NotificationEntity } from "@/apis/NotificationApi";
import { defineComponent } from "vue";
import { mapState } from "vuex";
import NotificationContactEdit from "@/modals/notificationContact/NotificationContactEdit.vue";

export default defineComponent({
  name: "NotificationContactReference",
  computed: {
    ...mapState("user", {
      contractSummary: "contractSummary",
    }),
  },
  data() {
    return {
      /** 初期通信完了フラグ */
      isLoaded: false,
      notificationContactInfo: { receivingType: {} } as NotificationEntity,
    };
  },
  async mounted() {
    await this.load();
    this.isLoaded = true;
  },
  methods: {
    /** データ取得 */
    async load() {
      this.notificationContactInfo =
        await this.$api.notification.getNotificationInfo();

      // 【24.04対応】メンテナンス情報と障害情報のメール送信を行わないため、falseを代入
      this.notificationContactInfo.receivingType.receivesMaintenance = false;
      this.notificationContactInfo.receivingType.receivesFailure = false;
    },
    /** 編集画面に画面遷移 */
    async editNotificationContact() {
      await this.$modal.show(NotificationContactEdit, {
        notificationContactInfo: this.notificationContactInfo,
      });
      await this.load();
    },
  },
});
</script>

<style lang="scss" scoped>
.content {
  max-width: 700px;
}
</style>
